<script setup lang="ts">
import { useData, useRoute } from 'vitepress';
import PageInfo from './PageInfo.vue';
const route = useRoute()
const { page, frontmatter, title } = useData()

</script>
<template>
  <div class="page-head">
    <h1 class="py-5 text-3xl font-bold page-head__title">{{ frontmatter.title || title || '' }}</h1>
    <PageInfo :page-data="{ ...page, url: route.path }" />
  </div>
</template>